import hsbc from './hsbc.jpg';
import bancoNacionArgentina from './banco_nacion_argentina.png';
import bbva from './bbva.jpg';
// import cacdu from './hsbc.jpg';
import bhu from './bhu.png';
import abnamrobank from './abnamaro.png';
import americaexpress from './america_express.png';
// import surinvest from './hsbc.jpg';
import cofac from './cofac.jpg';
import citibank from './citibank.jpg';
// import centrohispano from './hsbc.jpg';
import santander from './santander.jpg';
import banking from './banking.png';
import bankbrasil from './bancobrasil.png';
import bankdiscount from './bankdiscount.jpg';
// import bancocajaobrera from './hsbc.jpg';
import bacosudameris from './sudameris.png';
import brou from './brou.jpg';
import bancoreal from './banco_real.png';
// import bpa from './hsbc.jpg';
// import bancomontevideo from './hsbc.jpg';
import itau from './bancoitauuruguay.jpg';
// import bancodecredito from './hsbc.jpg';
// import caycu from './hsbc.jpg';
import scotiabankuruguay from './scotiabankuruguay.jpg';
import bandesuruguay from './bandes.jpg';
import visa from './visa.png';
import mastercard from './mastercard.png';

export const bankNames = {
  'hsbc republic national bank of new york': hsbc,
  'banco de la nacion argentina': bancoNacionArgentina,
  'banco bbva': bbva,
  // cacdu,
  bhu,
  'abn-amro bank': abnamrobank,
  'american express': americaexpress,
  // surinvest,
  cofac,
  citibank,
  // 'centro hispano': centrohispano,
  santander: 'Santander',
  'banco ing': banking,
  'banco de brasil': bankbrasil,
  'banco discount': bankdiscount,
  // 'bco. caja obrera': bancocajaobrera,
  'banco sudameris': bacosudameris,
  brou: 'Brou',
  'banco real': bancoreal,
  // bpa,
  // 'banco montevideo': bancomontevideo,
  'banco itau uruguay': itau,
  // 'banco de credito': bancodecredito,
  // 'credit uruguay': hsbc,
  // 'lloyds bank': hsbc,
  // 'banco comercial': hsbc,
  // caycu,
  'scotiabank uruguay': scotiabankuruguay,
  'bandes uruguay': bandesuruguay,
  visa: 'Visa',
  emprendimientosdevalor: 'Mastercard',
};

const bankImages = {
  'hsbc republic national bank of new york': hsbc,
  'banco de la nacion argentina': bancoNacionArgentina,
  'banco bbva': bbva,
  // cacdu,
  bhu,
  'abn-amro bank': abnamrobank,
  'american express': americaexpress,
  // surinvest,
  cofac,
  citibank,
  // 'centro hispano': centrohispano,
  santander,
  'banco ing': banking,
  'banco de brasil': bankbrasil,
  'banco discount': bankdiscount,
  // 'bco. caja obrera': bancocajaobrera,
  'banco sudameris': bacosudameris,
  brou,
  'banco real': bancoreal,
  // bpa,
  // 'banco montevideo': bancomontevideo,
  'banco itau uruguay': itau,
  // 'banco de credito': bancodecredito,
  // 'credit uruguay': hsbc,
  // 'lloyds bank': hsbc,
  // 'banco comercial': hsbc,
  // caycu,
  'scotiabank uruguay': scotiabankuruguay,
  'bandes uruguay': bandesuruguay,
  visa,
  emprendimientosdevalor: mastercard,
};

export default bankImages;



// WEBPACK FOOTER //
// ./src/assets/images/index.js